var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoMVideoBw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 117 19.5",
    style: {
      enableBackground: "new 0 0 117 19.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M3.5,17.2c3.1,0,4.7-3.1,6.2-7.3h0.2c-0.6,3.6-0.4,7.3,3,7.3c3.1,0,4.5-3.1,5.8-7.3H19 c-0.6,3.6-0.4,7.3,3.1,7.3c3.1,0,4.8-3.1,5.5-7.3h-2.2c-0.2,0.9-0.7,1.9-1.5,1.9c-1.7,0-0.8-2.8,0-6.3L25,0.3h-5.2 c0,0-2.7,11.4-4.9,11.4c-1.6,0-0.8-3.1-0.1-6.4l1-5.1h-5.2c-1,3.8-3,11.4-4.9,11.4c-0.6,0-0.8-0.4-0.8-0.9c0-0.3,0.1-0.7,0.2-1H0.4 c-0.2,1-0.4,2-0.4,3C0,15.3,0.9,17.2,3.5,17.2L3.5,17.2z M30.4,17.2c1.4,0,2.4-1.1,2.4-2.4s-1.1-2.4-2.4-2.4S28,13.5,28,14.8 S29.1,17.2,30.4,17.2z M44.4,11.7c0,1.1-0.8,1.6-1.8,1.6h-3.3V10h3.3C43.7,10,44.4,10.7,44.4,11.7C44.4,11.7,44.4,11.7,44.4,11.7z  M39.3,3.8h3c0.9,0,1.6,0.5,1.6,1.5s-0.8,1.5-1.6,1.5h-3V3.8L39.3,3.8L39.3,3.8z M45.7,8.2c1.2-0.5,2.5-1.6,2.5-3.7 c0-2.7-2-4.2-5.1-4.2h-8v16.5h8.1c3.1,0,5.5-1.5,5.5-4.6C48.7,10.1,47.4,8.7,45.7,8.2L45.7,8.2L45.7,8.2z M112.7,8.6 c0,2.3-1.5,4.5-4.3,4.5S104,11,104,8.6s1.5-4.5,4.3-4.5S112.7,6.2,112.7,8.6L112.7,8.6L112.7,8.6z M99.8,8.6c0,5,3.8,8.6,8.6,8.6 s8.6-3.7,8.6-8.6S113.2,0,108.4,0S99.8,3.7,99.8,8.6C99.8,8.6,99.8,8.6,99.8,8.6z M78,4.4v8.5h-5c0.7-1.5,1.1-4.5,1.1-8.3V4.4 L78,4.4L78,4.4L78,4.4z M82.2,12.9V0.3H70v1.3c0,5.7-0.3,10-1.6,11.3h-1.7v6.6H71v-2.6h9.4v2.6h4.2v-6.6L82.2,12.9L82.2,12.9z  M90.6,12.9v-2.4h6.9V6.6h-6.9V4.4h7.6v-4H86.3v16.5h12.1v-4L90.6,12.9L90.6,12.9z M61,0.3l-6,9.4V0.3h-4.2v16.5h4.2l6-9.4v9.4h4.2 V0.3H61z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMVideoBw);
export default __webpack_public_path__ + "static/media/Logo_MVideo_BW.20fff378ae47ec31763e6d60d36f938d.svg";
export { ForwardRef as ReactComponent };